import { ref } from "@vue/composition-api";

export const useInsertText = <T extends Element>() => {
  const elementRef = ref<T>();

  const insertText = (additionalText: string) => {
    if (!elementRef) {
      return;
    }

    const textAreaElement = elementRef.value?.querySelector(
      "textarea"
    ) as HTMLTextAreaElement;

    if (!textAreaElement) {
      return;
    }

    //IE support
    if ((document as any).selection) {
      textAreaElement.focus();
      const sel = (document as any).selection.createRange();
      sel.text = additionalText;
    }

    //MOZILLA and others
    else {
      var startPos = textAreaElement.selectionStart;
      var endPos = textAreaElement.selectionEnd;
      const nextText =
        textAreaElement.value.substring(0, startPos) +
        additionalText +
        textAreaElement.value.substring(endPos, textAreaElement.value.length);

      return nextText;
    }
  };

  return [elementRef, insertText] as const;
};
